import { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { api } from "utils/api"
import sortBy from "utils/sorter"

const AttendeeForms = ({ attendee }) => {
  const [requiredForms, setRequiredForms] = useState(null)
  const [status, setStatus] = useState(null)

  useEffect(() => {
    const attendeeRequiredForms = attendee.requiredForms.map(rf => ({
      id: rf.receiptForAttendee ? rf.receiptForAttendee.id : "",
      form_id: rf.id,
      ...(rf.receiptForAttendee && { received: "1" })
    }))

    setRequiredForms(attendeeRequiredForms)
  }, [])

  const handleClick = (e, requiredFormId) => {
    const updatedRequiredForms = requiredForms.map(rf =>
      rf.form_id === requiredFormId ? { ...rf, received: e.target.checked ? "1" : "0" } : rf
    )

    handleSubmit(updatedRequiredForms)
  }

  const handleSubmit = async attrs => {
    setStatus("loading")

    const response = await api.put(attendee.paths.formReceipts, {
      attendee: { form_receipts_attributes: attrs }
    })

    setRequiredForms(
      response.data.requiredForms.map(rf => ({
        id: rf.receiptForAttendee ? rf.receiptForAttendee.id : "",
        form_id: rf.id,
        ...(rf.receiptForAttendee && { received: "1" })
      }))
    )

    setStatus("saved")

    setTimeout(() => {
      setStatus(null)
    }, 2000)
  }

  return (
    <div
      className={`line p-2 p-r registration-details ${
        !attendee.requiredForms.length > 0 ? "d-n@print" : ""
      }`}
    >
      {status && (
        <div
          className={`p-a t-2 r-2 badge ${
            status === "loading" ? "warning-badge" : "success-badge"
          } d-n@print`}
        >
          {status === "loading" ? "Saving" : "Saved!"}
        </div>
      )}
      <h4 className="mb-2 fw-600 mt-1@print">Additional forms</h4>
      {!attendee.requiredForms.length > 0 && "No required forms"}
      <div>
        <ul className="unstyled mb-0">
          {sortBy("name", attendee.requiredForms).map((rf, i) => (
            <li
              key={rf.id}
              className={`d-f ai-c mb-1 ${
                rf.receiptForAttendee ? "" : "reg-details__item-incomplete"
              }`}
            >
              <input
                id={`${rf.id}-${attendee.id}-${i}`}
                type="checkbox"
                className="checkbox"
                defaultChecked={rf.receiptForAttendee ? true : false}
                disabled={status && status !== "saved"}
                onClick={e => handleClick(e, rf.id)}
              />
              <label className="checkbox-label" htmlFor={`${rf.id}-${attendee.id}-${i}`}>
                {rf.name}
              </label>
              {rf.receiptForAttendee && rf.receiptForAttendee.remote_url && (
                <a
                  href={rf.receiptForAttendee.remote_url}
                  target="_blank"
                  rel="noreferrer"
                  className="ml-1 btn-outline interaction xs"
                >
                  View submission
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

AttendeeForms.propTypes = {
  attendee: PropTypes.shape({
    id: PropTypes.number,
    requiredForms: PropTypes.array,
    paths: PropTypes.shape({
      formReceipts: PropTypes.string
    })
  })
}

export default AttendeeForms
